"use client"
import Link from "next/link"
import { useRouter } from "next/router"
import { Search } from "components/ui"
import cn from "classnames"
import s from "./Navbar.module.css"
import { useEffect, useRef, useState } from "react"
import Notification from "components/Notification/Notification"
import { apiNoticatoin } from "api"
import { messaging } from "lib/firebase"
import { getAccessToken } from "lib/Cookies"
import { onMessage } from "firebase/messaging"
import useStore from "components/ui/Context"
import dynamic from "next/dynamic"
import { getMobileOperatingSystem } from "lib/func"
import NavbarMobile from "./NavbarMobile"

const Profile = dynamic(() => import("components/common/Profile"), { ssr: false })

export default function Navbar(props) {
  const router = useRouter()
  const [index, setIndex] = useState("/")
  const [isBlack, setIsBlack] = useState(false)
  const isMounter = useRef()
  const [isShowNoti, setIsShowNoti] = useState(false)
  const [count, setCount] = useState(0)
  const { userInfo } = useStore()
  const [isNav, setIsNav] = useState(false)
  const [showSearch, setShowSearch] = useState(false)
  const [text, setText] = useState(router?.query?.q || "")
  const [isClient, setIsClient] = useState(false)
  const mobileOS = getMobileOperatingSystem()

  useEffect(() => {
    setIsClient(true)
  }, [])

  async function getCountNoti() {
    try {
      if (getAccessToken()) {
        const { data } = await apiNoticatoin.getCount()
        setCount(data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setIndex(router.asPath)
  }, [router])

  useEffect(() => {
    if (getAccessToken()) {
      getCountNoti()
    }
  }, [userInfo])

  function togleIsMobile() {
    // if (window.innerWidth < 640) {
    if (window.innerWidth < 1200) {
      props.setIsCollapsed(true)
      props.setIsMobile(true)
    } else {
      props.setIsCollapsed(false)
      props.setIsMobile(false)
    }
  }

  useEffect(() => {
    if (getAccessToken()) {
      getCountNoti()
    }
    togleIsMobile()
    window.addEventListener("resize", () => {
      togleIsMobile()
    })
    return () => {
      if (props.isMobile) window?.removeEventListener("resize", togleIsMobile)
    }
  }, [])

  useEffect(() => {
    onMessage(messaging, (payload) => {
      if (payload?.messageId) {
        const timer = setTimeout(() => {
          getCountNoti()
        }, [2000])
        return () => {
          clearTimeout(timer)
        }
      }
      // ...
    })
  }, [])

  function onSearch() {
    if (!props.isMobile) {
      if (!router.pathname.includes("tim-kiem") && text.length <= 0) {
        setShowSearch(!showSearch)
      } else if (text.length > 0) {
        router.push(`/tim-kiem?q=${text}`)
        setShowSearch(true)
      }
      setIsShowNoti(false)
    } else {
      router.push(`/tim-kiem`)
    }
  }

  function onChange(e) {
    setText(e.target.value)
  }

  function onKeyPress(e) {
    if (e.keyCode === 13 && text.length > 0) {
      router.push(`/tim-kiem?q=${text}`)
    }
  }

  useEffect(() => {
    if (router.pathname !== "/tim-kiem") setText("")
  }, [router])

  const routerSubs = router.pathname === "/subscription"

  return (
    <>
      {/* {props ? ( */}
      {!props.isMobile ? (
        <nav
          className={cn(s.nav, "py-4 px-8 top-0 w-full fixed z-40 flex justify-center")}
          id="nav"
          onClick={() => setIsShowNoti(false)}
        >
          <div className="container__screen w-full justify-between items-center flex relative">
            <div className="flex relative items-center gap-10 lg:gap-[60px] 2xl:gap-10 3xl:gap-[60px]">
              <Link href="/" onClick={() => setIsShowNoti(false)}>
                <div className="py-1 flex md:hidden min-[1100px]:block">
                  <img width={80} height={44} src="/logoOnliveTV.png" alt="xx" />
                </div>
              </Link>
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2  items-center hidden md:flex">
              <Search />
            </div>
            <div className="flex justify-center items-center gap-3">
              {/* <Link href="/subscription" onClick={() => setIsShowNoti(false)}>
                <div
                  className={`rounded-[100px] p-1 w-[44px] h-[44px] flex justify-center items-center ${
                    routerSubs && "bg-button"
                  }`}
                >
                  <img src="/icons/iconDiamond.svg" />
                </div>
              </Link> */}
              {isClient && (
                <div
                  onClick={(e) => {
                    e.stopPropagation()
                    setIsShowNoti(!isShowNoti)
                  }}
                  className={cn(
                    s.bell,
                    "cursor-pointer rounded-[100px] p-1 w-[44px] h-[44px] flex justify-center items-center relative bell",
                    {
                      "bg-button": isShowNoti
                    }
                  )}
                >
                  {!getAccessToken() ? (
                    <img src="/icons/iconBellStroke.svg" />
                  ) : count > 0 ? (
                    isShowNoti ? (
                      <img src="/icons/iconBellBlueStrokeNoti.svg" />
                    ) : (
                      <img src="/icons/iconBellStrokeNoti.svg" />
                    )
                  ) : isShowNoti ? (
                    <img src="/icons/iconBellBlueStroke.svg" />
                  ) : (
                    <img src="/icons/iconBellStroke.svg" />
                  )}
                  {isShowNoti && (
                    <Notification
                      callBackgetCountNoti={getCountNoti}
                      setIsShowNoti={setIsShowNoti}
                      typeShow={"popup"}
                    />
                  )}
                </div>
              )}
              <div onClick={() => setIsShowNoti(false)}>
                <Profile />
              </div>
            </div>
          </div>
        </nav>
      ) : (
        <>
          <nav
            className={cn(s.nav, "top-0 w-full px-4 fixed z-40 flex md:px-3 justify-between py-2 h-[60px]")}
            id="nav"
          >
            <div className="flex space-x-3 items-center" onClick={() => setIsShowNoti(false)}>
              <button onClick={() => setIsNav(!isNav)} className={`text-slate-200 rounded z-40`}>
                <img src="/icons/iconMenuMobile.svg" />
              </button>

              <Link href="/" onClick={() => setIsShowNoti(false)}>
                <img width={66} height={36} src="/logoOnliveTV.png" alt="xx" />
              </Link>
            </div>
            <div className="flex items-center gap-2.5">
              <button onClick={onSearch} className="text-primary-dark rounded cursor-pointer p-1">
                <img src="/icons/iconSearchMobile.svg" width={24} />
              </button>
              {/* <div className="relative">
                <input
                  value={text}
                  onChange={onChange}
                  onKeyDown={onKeyPress}
                  className={showSearch ? "show__input__search" : "hide__input__search"}
                  placeholder="Tìm kiếm"
                  tabIndex={0}
                />
              </div> */}
              <div
                onClick={(e) => {
                  e.stopPropagation()
                  router.push("/notification")
                }}
                className={cn(s.bell, "cursor-pointer flex rounded-[100px] p-1", {
                  "bg-button": isShowNoti
                })}
              >
                {!getAccessToken() ? (
                  <img src="/icons/iconBellStroke.svg" width={24} />
                ) : count > 0 ? (
                  isShowNoti ? (
                    <img src="/icons/iconBellBlueStrokeNoti.svg" width={24} />
                  ) : (
                    <img src="/icons/iconBellStrokeNoti.svg" width={24} />
                  )
                ) : isShowNoti ? (
                  <img src="/icons/iconBellBlueStroke.svg" width={24} />
                ) : (
                  <img src="/icons/iconBellStroke.svg" width={24} />
                )}
              </div>
              <div onClick={() => setIsShowNoti(false)}>
                <Profile />
              </div>
            </div>
            <NavbarMobile isNav={isNav} setIsNav={() => setIsNav(!isNav)} />
          </nav>
        </>
      )}
    </>
  )
}
